import { render, staticRenderFns } from "./InvestmentActive.vue?vue&type=template&id=0b448890"
import script from "./InvestmentActive.vue?vue&type=script&lang=js"
export * from "./InvestmentActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports